import React from "react";
import BigNumber from "bignumber.js";

const exchangeTypeTicker = (props) => (
    <div className="box-kline-para-basic-right">
  <ul>
    <li>
      <h4 className="ng-binding">Last Price</h4>
      <strong className="ng-binding">
        <span
          className={
            new BigNumber(props.close).gte(new BigNumber(props.last))
              ? ""
              : "text-danger"
          }
        >
          {new BigNumber(props.close<0.0001 && props.close>0.000001?parseFloat(props.close).toFixed(8):props.close<0.1 && props.close>0.0001?parseFloat(props.close).toFixed(6):props.close<1 && props.close>0.1?parseFloat(props.close).toFixed(4):props.close>1?parseFloat(props.close).toFixed(2):parseFloat(props.close).toFixed(2)).toFormat(null,1)}
          {/* {new BigNumber(props.close).toFormat(null, 1)} */}
        </span>
      </strong>
    </li>
    <li>
      <h4 className="ng-binding">24h-Change</h4>
      <strong>
        {" "}
        {new BigNumber(props.change).toFormat(null, 1)}{" "}&nbsp;
        {props.percentage && new BigNumber(props.percentage<0.0001 && props.percentage>0.000001?parseFloat(props.percentage).toFixed(8):props.percentage<0.1 && props.percentage>0.0001?parseFloat(props.percentage).toFixed(6):props.percentage<1 && props.percentage>0.1?parseFloat(props.percentage).toFixed(4):props.percentage>1?parseFloat(props.percentage).toFixed(2):parseFloat(props.percentage).toFixed(2)).toFormat(null,1)}{" "}%
      </strong>
    </li>
    <li>
      <h4 className="ng-binding">24h-High</h4>
      <strong className="ng-binding">
      {new BigNumber(props.high<0.0001 && props.high>0.000001?parseFloat(props.high).toFixed(8):props.high<0.1 && props.high>0.0001?parseFloat(props.high).toFixed(6):props.high<1 && props.high>0.1?parseFloat(props.high).toFixed(4):props.high>1?parseFloat(props.high).toFixed(2):parseFloat(props.high).toFixed(2)).toFormat(null,1)}
        {/* {new BigNumber(props.high).toFormat(null, 1)} */}
      </strong>
    </li>
    <li>
      <h4 className="ng-binding">24h-Low</h4>
      <strong className="ng-binding">
      {new BigNumber(props.low<0.0001 && props.low>0.000001?parseFloat(props.low).toFixed(8):props.low<0.1 && props.low>0.0001?parseFloat(props.low).toFixed(6):props.low<1 && props.low>0.1?parseFloat(props.low).toFixed(4):props.low>1?parseFloat(props.low).toFixed(2):parseFloat(props.low).toFixed(2)).toFormat(null,1)}
        {/* {new BigNumber(props.low).toFormat(null, 1)} */}
      </strong>
    </li>
    <li>
      <h4 className="ng-binding">24h Volume</h4>
      <strong className="ng-binding">
      {/* {console.log("props.vol==========",props)} */}
        {props.quoteVolume ? new BigNumber(props.quoteVolume<0.0001 && props.quoteVolume>0.000001?parseFloat(props.quoteVolume).toFixed(8):props.quoteVolume<0.1 && props.quoteVolume>0.0001?parseFloat(props.quoteVolume).toFixed(6):props.quoteVolume<1 && props.quoteVolume>0.1?parseFloat(props.quoteVolume).toFixed(4):props.quoteVolume>1?parseFloat(props.quoteVolume).toFixed(2):parseFloat(props.quoteVolume).toFixed(2)).toFormat(null,1):0}{" "}
        {props.symbol.length === 7 ? props.symbol.slice(-4) : props.symbol.slice(-4)}
      </strong>
    </li>
  </ul>
  <div className="cls"></div>
</div>
);

export default exchangeTypeTicker;
